import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import config from "./aws-exports.js";
import Amplify from "aws-amplify";
import { Client, defaultExchanges, subscriptionExchange, Provider } from "urql";
import { SubscriptionClient } from "subscriptions-transport-ws";
import { configureS3 } from "./services/storageService";
require("dotenv").config({ path: __dirname + "/.env" });

// const ENDPOINT = "ec2-13-211-85-237.ap-southeast-2.compute.amazonaws.com";
const ENDPOINT = "api.crowdeagle.com.au";
// const ENDPOINT = "localhost:4000";

async function main() {
  Amplify.configure(config);

  //For AWS Graphql Client
  Amplify.configure({
    API: {
      // graphql_endpoint: "http://localhost:4000/graphql/",
      graphql_endpoint: `https://${ENDPOINT}/graphql/`,
    },
  });

  //For urql Graphql Client
  const subscriptionClient = new SubscriptionClient(
    `wss://${ENDPOINT}/graphql`,
    {}
  );

  const urqlClient = new Client({
    // url: "/graphql",
    url: `https://${ENDPOINT}/graphql`,
    exchanges: [
      ...defaultExchanges,
      subscriptionExchange({
        forwardSubscription: operation => subscriptionClient.request(operation),
      }),
    ],
  });

  //Configure AWS S3 sdk
  await configureS3();

  ReactDOM.render(
    <Provider value={urqlClient}>
      <App />
    </Provider>,
    document.getElementById("root")
  );
}
main();
